module.exports = __webpack_public_path__ + "img/idcard4.df2ff4d8.png";